/**
 * Added to entities that should have the rotate option in the context menu when selected.
 */
class RotatableComponent {
    constructor() {
        this.typeId = RotatableComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
RotatableComponent.id = 2088;
export default RotatableComponent;
//# sourceMappingURL=RotatableComponent.js.map